import { Link } from 'react-router-dom';

const footerLinks = {
  explore: [
    { label: '东亚春色', to: '/category/east-asia' },
    { label: '东南亚春色', to: '/category/southeast-asia' },
    { label: '南亚春色', to: '/category/south-asia' },
  ],
  articles: [
    { label: '日本樱花攻略', to: '/article/japan-sakura-guide' },
    { label: '韩国春日花海', to: '/article/korea-spring-flowers' },
    { label: '江南古镇巡礼', to: '/article/china-jiangnan-spring' },
  ],
  about: [
    { label: '关于我们', to: '/about' },
    { label: '品牌故事', to: '/about' },
    { label: '联系我们', to: '/about' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="w-full px-6 md:px-10 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="text-lg font-semibold text-foreground-950 whitespace-nowrap">
              亚洲春色
            </Link>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed max-w-xs">
              汇聚东亚、东南亚、南亚春季最绚烂的自然与人文景观，带你领略樱花、油菜花、热带花海的极致美景。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">
              <a href="#explore-section" className="hover:text-primary-500 transition-colors">探索春色</a>
            </h4>
            <ul className="space-y-2">
              {footerLinks.explore.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">
              <a href="#articles-section" className="hover:text-primary-500 transition-colors">精选文章</a>
            </h4>
            <ul className="space-y-2">
              {footerLinks.articles.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">
              <a href="#about-section" className="hover:text-primary-500 transition-colors">关于</a>
            </h4>
            <ul className="space-y-2">
              {footerLinks.about.map((link) => (
                <li key={link.label}>
                  <Link to={link.to} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 亚洲春色. All rights reserved.
          </p>
          <div className="flex items-center gap-4 text-foreground-500">
            <a href="https://weibo.com" target="_blank" rel="nofollow noopener noreferrer" className="hover:text-primary-500 transition-colors" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="https://weixin.qq.com" target="_blank" rel="nofollow noopener noreferrer" className="hover:text-primary-500 transition-colors" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-instagram-line text-lg cursor-pointer hover:text-primary-500 transition-colors"></i>
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}